<template>
  <div>
    <b-container>
      <b-jumbotron lead="Anhand der Seitenzahlen im Buch" id="search-jumbo">
        <h2 slot="header">Resourcen nachschlagen</h2>

        <div class="text-center">
          <p class="text-muted mb-0">Seitenzahl auswählen</p>
          <b-pagination
            v-model="searchInput"
            :total-rows="lastPage"
            :per-page="1"
            align="center"
            :hide-goto-end-buttons="true"
          ></b-pagination>
        </div>

        <div class="mt-4 text-center">
          <resource-type-filter :disabled="searchInput === ''" ref="resourceTypeFilter" enable-default="audio"></resource-type-filter>
        </div>
        <div class="mt-2 text-center d-none">
          <resource-lang-filter :disabled="searchInput === ''" ref="resourceLangFilter" :enable-default-all="true"></resource-lang-filter>
        </div>
      </b-jumbotron>
    </b-container>

    <b-container>
      <b-row>
        <b-col class="mb-4" cols="12" v-for="resource in searchResult" :key="resource.filePath  ">
          <resource :resource="resource"></resource>
        </b-col>

        <b-col v-if="searchResult.length <= 0 && searchInput !== ''" id="no-search-results" class="fadeIn animated">
          <h3>Keine Ergebnisse gefunden!</h3>
          <p>Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien für die Seite <code>{{ searchInput }}</code> gefunden werden.</p>
          <p>Dies kann auch daran liegen, dass noch keine Zusatzmaterialien für diese Seite erstellt wurden.</p>
        </b-col>

        <b-col v-if="searchInput === ''" id="no-search-results-no-input" class="fadeIn animated">
          <h3>Ungültige Seite aufgerufen</h3>
          <p>Sie haben leider einen ungültigen Link aufgerufen.</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Resource from './Resource'
  import ResourceTypeFilter from './ResourceTypeFilter'
  import ResourceLangFilter from './ResourceLangFilter'

  const Loki = require('lokijs')

  export default {
    name: 'ResourceLookup',
    data () {
      return {
        searchInput: 1
      }
    },
    components: {
      Resource,
      ResourceTypeFilter,
      ResourceLangFilter
    },
    mounted () {
      this.$http.get('/static/resourceDB.json').then(function (response) {
        this.db = new Loki('resources')
        this.db.loadJSONObject(response.body)
        this.resourceCollection = this.db.getCollection('resources')

        if (this.$route.params.lang) {
          this.$refs.resourceLangFilter.selectOnlyLang(this.$route.params.lang)
          if (this.$route.params.page) {
            const intInput = parseInt(this.$route.params.page)
            if (!isNaN(intInput)) {
              this.searchInput = intInput
            }
          }
        }
      })
    },
    watch: {
      searchInput: function (newVal, oldVal) {
        if (oldVal !== 1 && oldVal !== newVal) {
          this.$router.push({path: `/resources/lookup/${this.$route.params.lang}/page/${newVal}`})
        }
      }
    },
    computed: {
      filteredResources: function () {
        if (this.resourceCollection !== null && this.resourceCollection !== undefined) {
          console.log('go')
          return this.resourceCollection.chain().where((obj) => {
            if (this.$refs.resourceTypeFilter !== undefined) {
              return this.$refs.resourceTypeFilter.filterSelectedObjects(obj)
            }
            return false
          }).where((obj) => {
            if (this.$refs.resourceLangFilter !== undefined) {
              return this.$refs.resourceLangFilter.filterSelectedObjects(obj)
            }
            return false
          })
        }
      },
      lastPage: function () {
        if (this.resourceCollection === null || this.resourceCollection === undefined) {
          return 999
        }
        const lastRow = this.filteredResources.branch().simplesort('page', 'DESC').limit(1).data()
        return lastRow['page']
      },
      searchResult: function () {
        if (this.searchInput === '' || this.resourceCollection === undefined || this.resourceCollection === null) {
          return []
        }

        //

        return this.filteredResources.branch().where((obj) => {
          const intInput = parseInt(this.searchInput)
          if (!isNaN(intInput)) {
            if (obj['page'] === intInput) {
              return true
            }
          }
          return false
        }).simplesort('page').data()
      }
    },
    methods: {
      getLanguageString (lang) {
        if (lang === 'ar') {
          return 'Arabisch'
        } else if (lang === 'tr') {
          return 'Türkisch'
        } else if (lang === 'pr') {
          return 'Persisch'
        } else {
          return 'Unbekannt'
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
  @import '~animate.css/animate.css';

  .container {
    margin-top: 15px;
  }

  #no-search-results {
    animation-delay: .5s;
  }

  #search-jumbo {
    position: relative;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResourceLookup.vue